import classNames from 'classnames';
import { FC } from 'react';

import {
  EventDetailItem,
  EventItem,
  isPastEventEnd,
} from '@/entities/event';
import { EventRequestForm, EventWaitListRequestForm } from '@/features/event';
import {
  formatEventDateRu,
  formatEventTimeRu,
  formatPrice,
} from '@/shared/lib';

import styles from './eventForm.module.scss';

type EventItemProps = {
  event: EventItem & EventDetailItem;
};

const FALLBACK_LOCATION = '-';

const EventForm: FC<EventItemProps> = ({ event }) => {
  if (isPastEventEnd(event.end_at)) {
    return null;
  }

  const location = event.address.trim() ? event.address : FALLBACK_LOCATION;
  const noSeatsLeft = event.available_seats === 0;

  const modalPayload = {
    slug: event.slug,
    title: event.title,
    startAt: event.start_at,
    location,
    price: event.price,
  };

  return (
    <section className={classNames('container', styles.section)}>
      <div className={styles.section__wrapper}>
        <div className={styles.section__left}>
          <div className={styles.section__headBlock}>
            <h3 className={styles.section__head}>
              {noSeatsLeft ? (
                <>
                  Лист ожидания
                  <br className={classNames('is-desk')} /> на мероприятие
                </>
              ) : (
                <>
                  Регистрация
                  <br className={classNames('is-desk')} /> на мероприятие
                </>
              )}
            </h3>
          </div>
          <div className={styles.section__left_item}>
            <p>Цена билета</p>
            <p className={styles.section__price}>{formatPrice(event.price)}</p>
          </div>
          <div className={styles.section__left_item}>
            <p>Дата и время</p>
            <p>
              {`${formatEventDateRu(event.start_at)} ${formatEventTimeRu(event.start_at)}-${formatEventTimeRu(event.end_at)}`}
            </p>
          </div>
          <div>
            <p>Адрес</p>
            <p>{event.address.trim() ? event.address : FALLBACK_LOCATION}</p>
          </div>
        </div>
        <div className={styles.section__right}>
          {noSeatsLeft ? (
            <EventWaitListRequestForm event={modalPayload} variant="inline" />
          ) : (
            <EventRequestForm event={modalPayload} variant="inline" />
          )}
        </div>
      </div>
    </section>
  );
};

export default EventForm;
